module.exports = __webpack_public_path__ + "img/fun_m_3.749d97a7.png";